import { render, staticRenderFns } from "./ElixioWalletTransactionsManager.vue?vue&type=template&id=19068a36&"
import script from "./ElixioWalletTransactionsManager.vue?vue&type=script&lang=js&"
export * from "./ElixioWalletTransactionsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports